<div class="mx-auto max-w-md">
  <app-card>
    <form
      [formGroup]="resetPasswordForm"
      (ngSubmit)="sendPassword()"
      class="space-y-5"
    >
      @if (showAlert) {
        <app-alert [severity]="severity" [message]="message" />
      }

      <div>
        <h1 class="text-xl font-bold text-fg">Wachtwoord vergeten</h1>
        <p class="mt-1 text-sm text-fg-muted">
          Vul je e-mailadres in, dan sturen we je een link om een nieuw
          wachtwoord in te stellen.
        </p>
      </div>

      <app-field label="E-mailadres" for="email" [control]="email">
        <input
          appInput
          [control]="email"
          formControlName="email"
          id="email"
          type="email"
          autocomplete="email"
          placeholder="jij@voorbeeld.be"
        />
      </app-field>

      <button
        appButton
        type="submit"
        class="w-full"
        [disabled]="
          resetPasswordForm.invalid || resetPasswordForm.pending || inSubmission
        "
      >
        Verstuur resetlink
      </button>

      <p class="text-sm text-fg-muted">
        Weet je het weer?
        <a
          routerLink="/login"
          class="font-semibold text-fg hover:text-brand hover:underline"
        >
          Inloggen
        </a>
      </p>
    </form>
  </app-card>
</div>
